// Keep an uncertain financial attempt's ID while the page remains open.
// Concurrent clicks and retries of the same intent share a server replay key.
export function createMutationKeys() {
  const attempts = new Map();
  return {
    prepare(config, identity, generate = () => crypto.randomUUID()) {
      if (['get','head','options'].includes(config.method) || !/^\/(?:admin\/operations\/(?:deposit|withdraw|transfer)|user\/(?:boxes|bank-boxes|goals|vaults|shared-goals|shared-vaults|approvals\/request|currency-exchange|subscription\/purchase|store\/purchases))(?:\/|$)/.test(config.url || '')) return config;
      let body = config.data;
      if (typeof body === 'string') { try { body = JSON.parse(body); } catch { return config; } }
      if (!body || Object.getPrototypeOf(body) !== Object.prototype) return config;
      const intent = { ...body }; delete intent.request_id;
      const key = `${identity}:${config.method}:${config.url}:${JSON.stringify(intent)}`;
      const id = attempts.get(key) || body.request_id || config.headers?.['Idempotency-Key'] || generate();
      attempts.set(key,id); config._financialIntent = key;
      config.data = { ...body, request_id:id };
      config.headers['Idempotency-Key'] = id;
      return config;
    },
    settle(config, status) {
      // A lost response or server failure leaves the outcome uncertain.
      if (status && status < 500 && status !== 408 && config?._financialIntent) attempts.delete(config._financialIntent);
    }
  };
}
